// extracted by mini-css-extract-plugin
module.exports = {"root":"Tabs_root__jsAJC","tab":"Tabs_tab__2Bu7W","tabActive":"Tabs_tabActive__2tCfN"};